import { Grid } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IForm from '../../../components/i-form/i-form.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import { getSupplierById, saveSupplier } from '../supplier.services';
import { isNotNull } from '../../common/util.services';
import { LABOR_INPUT } from '../../common/constants';
import IMultiSelect from '../../../components/text-component/multiselect/i-multiselect.component';
import { MATERIAL_SPECS_MAP, PROCESS_SPECS_MAP } from '../../master-data/specs/specs.mapping';

const SupplierForm = () => {
  const [title, setTitle] = useState<string>('Add Supplier');
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const params = useParams()
  const rowId = params.rowId;
  const [supplierData, setSupplierData] = useState<any>({products:[], city:[]});
  const [loader, setLoader] = useState(true);
  const [supplierProducts, setSupplierProducts] = useState<string[]>();

  useEffect(() => {
    setSupplierProducts((Object.keys(MATERIAL_SPECS_MAP).concat
                        (Object.keys(PROCESS_SPECS_MAP)).concat
                        (['Transport']).concat
                        (LABOR_INPUT).concat
                        (['Accessories'])).sort());
    if (isNotNull(rowId)) {
      getSupplierById(rowId, appContext,
        (response: any) => {
          setTitle('Edit Supplier');
          setSupplierData(response.data);
          setLoader(false);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoader(false);
        });
    } else {
      setLoader(false);
    }
  }, []);
  const onSubmit = (data: any) => {
    saveSupplier(data, appContext,
      (response: any) => {
        navigate('/supplier/list');
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
  }

  const getMainComponent = () => {
    return <Grid container spacing={1}>
      <Grid xs={3}>
        <ITextField name='name' label='Name' required={true} disabled={isNotNull(rowId)} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='code' label='Code' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='primaryContact' label='Primary Contact' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField type="phone" name='primaryNumber' label='Primary Number' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField type="email" name='primaryMail' label='Primary Mail' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='secondaryContact' label='Secondary Contact' />
      </Grid>
      <Grid xs={3}>
        <ITextField type="phone" name='secondaryNumber' label='Secondary Number' />
      </Grid>
      <Grid xs={3}>
        <ITextField type="email" name='secondaryMail' label='Secondary Mail' />
      </Grid>
      <Grid xs={3}>
        <ITextField name='city' label='City' required={true} />
      </Grid>
      <Grid xs={3}>
        <IMultiSelect name='products' label='Products' required={true} itemList={supplierProducts} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='address1' label='Address Line 1' required={false} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='address2' label='Address Line 2' required={false} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='address3' label='Address Line 3' required={false} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='gstin' label='GSTIN' required={true} />
      </Grid>
    </Grid>
  }

  return loader ? <></> : <IForm formData={supplierData} title={title} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default SupplierForm;